import type { DataTypeLocator } from '@helo/cms'

import { Options } from '../../Options'
import { ChartDataConstants } from './ChartData.constants'

const dataTypeLocatorOfType = Options.scalar<DataTypeLocator>('DataTypeLocator')

export type ChartDataFilter = readonly string[]

export const chartDataOptions = Options.asRecord(
  Options.createOption({
    key: 'dimensionLocator',
    inputKind: 'data_type_locator',
    required: true,
    ofType: dataTypeLocatorOfType,
    label: 'Dimension',
    description: 'Field locator for the categorical X-axis dimension.',
    category: 'Data',
  }),
  Options.createOption({
    key: 'dataTopN',
    inputKind: 'number',
    min: 1,
    step: 1,
    label: 'Top N',
    description: 'Keep the top N categories by the first measure.',
    category: 'Data',
  }),
  Options.createOption({
    key: 'dataSort',
    inputKind: 'select',
    selectChoices: [
      { value: 'natural', label: 'Natural' },
      { value: 'dimension_asc', label: 'Dimension ascending' },
      { value: 'dimension_desc', label: 'Dimension descending' },
      { value: 'measure_asc', label: 'Measure ascending' },
      { value: 'measure_desc', label: 'Measure descending' },
    ],
    defaultValue: 'natural',
    label: 'Data sort',
    description: 'Order retrieved categories before visualization.',
    category: 'Data',
  }),
  Options.createOption({
    key: 'dataFilter',
    inputKind: 'category_filter',
    ofType: Options.list(Options.scalar<string>('String')),
    label: 'Data filter',
    description: 'Category values to retain after retrieval.',
    category: 'Data',
  }),
  Options.createOption({
    key: 'nullValueBehavior',
    inputKind: 'select',
    selectChoices: [
      { value: 'gap', label: 'Gap' },
      { value: 'connect', label: 'Connect' },
    ],
    defaultValue: ChartDataConstants.defaultNullValueBehavior,
    label: 'Null value behavior',
    description:
      'How missing measure values are drawn: break the line (gap), or skip points (connect).',
    category: 'Data',
  }),
)

export type ChartDataOptions = Options.TypeOf<typeof chartDataOptions>
export type ChartNullValueBehavior = Options.ResolvedTypeOf<
  typeof chartDataOptions
>['nullValueBehavior']
export type ChartDataSort = Options.ResolvedTypeOf<
  typeof chartDataOptions
>['dataSort']
